import { render } from "./jygz.vue?vue&type=template&id=4f688b41&scoped=true"
import script from "./jygz.vue?vue&type=script&lang=js"
export * from "./jygz.vue?vue&type=script&lang=js"

import "./jygz.vue?vue&type=style&index=0&id=4f688b41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f688b41"]])

export default __exports__